import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/Card";
import { Button } from "../ui/Button";
import { CheckCircledIcon, ArrowRightIcon } from "@radix-ui/react-icons";

interface RegistrationCompleteProps {
  onContinue: () => void;
}

export const RegistrationComplete: React.FC<RegistrationCompleteProps> = ({ onContinue }) => {
  return (
    <Card className="w-full max-w-md bg-white shadow-none border border-border-gray rounded-none">
      <CardHeader className="text-center space-y-4 pt-12 pb-8">
        <CardTitle className="text-xl font-bold uppercase tracking-wide">
          REGISTRATION COMPLETE!
        </CardTitle>
        <CardDescription className="text-sm text-gray-600">
          Congratulations, your account
          <br />
          has been successfully created
        </CardDescription>
      </CardHeader>
      <CardContent className="px-8 pb-12">
        <Button
          onClick={onContinue}
          className="w-full h-12 bg-primary-blue hover:bg-primary-blue/90 text-white font-normal rounded-none"
        >
          Go to Home Page
        </Button>
      </CardContent>
    </Card>
  );
};
